<template>
  <site-shell :user="session.status === 'ready' ? session.user : visitor" :branding="branding">
    <router-view v-if="!sessionRequired" @branding="branding = $event" @visitor="visitor = $event" />
    <div v-else-if="session.status === 'loading'" class="session-state" role="status">Loading your session…</div>
    <div v-else-if="session.status === 'expired'" role="alert" class="session-state auth-notice">Your session has expired. <a :href="loginUrl">Log in to continue</a>.</div>
    <div v-else-if="session.status === 'error'" role="alert" class="session-state auth-notice">Unable to load your session. <AppButton @click="load">Try again</AppButton></div>
    <router-view v-else v-slot="{ Component }"><keep-alive include="SettingsForm"><component :is="Component" :key="$route.meta.viewKey || $route.path" /></keep-alive></router-view>
  </site-shell>
</template>
<script>
import SiteShell from './SiteShell.vue';
import AppButton from '../components/ui/AppButton.vue';
export default {
  components: { SiteShell, AppButton },
  props: { sessionRequired: { type: Boolean, default: true } },
  data() { return { branding: null, visitor: null }; },
  computed: {
    session() { return this.$store.state.session; },
    loginUrl() { return '/login?returnUrl=' + encodeURIComponent(location.pathname + location.search + location.hash); }
  },
  methods: { async load() { await this.$store.dispatch('session/load'); } },
  created() { if (this.sessionRequired) this.load(); }
};
</script>
<style scoped>
.session-state { width: calc(100% - 2rem); max-width: 1127px; margin: 1rem auto; }
.session-state a { display: inline-flex; align-items: center; min-height: 44px; text-decoration: underline; }
</style>
